"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Link_1 = tslib_1.__importDefault(require("@mui/material/Link"));
const ListItemAvatar_1 = tslib_1.__importDefault(require("@mui/material/ListItemAvatar"));
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const styles_1 = require("@mui/material/styles");
const styles_2 = require("@mui/material/styles");
const NavAvatarIcon_1 = tslib_1.__importDefault(require("../_InternalComponents/NavAvatarIcon"));
const stringToAvatarLetters_1 = require("../_InternalUtils/stringToAvatarLetters");
const ServiceNavLink = (0, styles_1.styled)(Link_1.default)({
    display: "inherit",
    textTransform: "capitalize",
    width: "100%",
});
const ServiceNavIcon = (0, styles_1.styled)(ListItemIcon_1.default)({
    "& svg": {
        height: "inherit",
    },
});
const ServiceNavigationListItem = (props) => {
    const { icon, text, isSelected, ...rest } = props;
    return (react_1.default.createElement(material_1.ListItemButton, { sx: {
            "&:hover": {
                bgcolor: ({ palette }) => (0, styles_2.alpha)((0, styles_2.hexToRgb)(palette.primary.main), 0.04),
            },
        }, selected: isSelected },
        react_1.default.createElement(ServiceNavLink, { underline: "none", noWrap: true, display: "inline", ...rest },
            !icon && (react_1.default.createElement(ListItemAvatar_1.default, null,
                react_1.default.createElement(NavAvatarIcon_1.default, { text: (0, stringToAvatarLetters_1.stringToAvatarLetters)(text) }))),
            icon && react_1.default.createElement(ServiceNavIcon, null, icon),
            react_1.default.createElement(ListItemText_1.default, { primary: text, primaryTypographyProps: { sx: { overflow: "hidden", textOverflow: "ellipsis" } }, title: text }))));
};
exports.default = ServiceNavigationListItem;
